export const FUNNEL_COMMENT_ACTIONS = {
    REJECT: 'REJECT',
    APPROVE: 'APPROVE',
    MARK_AS_PERSONAL: 'MARK_AS_PERSONAL'
}
